import React from 'react'
import PropTypes from 'prop-types'
import { getPaletteColor, Text, Card, Button } from 'pcln-design-system'
import styled from 'styled-components'

const BorderTopBox = styled(Card)`
  border-top: 6px solid ${getPaletteColor('primary.base')};
`

const StyledText = styled(Text)`
  white-space: nowrap;
`

const RefundText = styled(Text)`
  text-decoration: underline;
`

export default function BestPriceGuaranteeCard({
  whenClicked,
  ariaLabel = 'Best Price Guaranteed Information',
}) {
  return (
    <BorderTopBox width={1} bg='text.lightest' borderRadius='xl' align='center' p={'12px'} boxShadowSize='sm'>
      <Text fontSize={1} mb={2}>
        <Text.span bold color='brand.primary'>
          {' '}
          Best Price.{' '}
        </Text.span>
        <Text.span bold color='alert.base'>
          GUARANTEED.
        </Text.span>
      </Text>
      <StyledText mb={1} color='text.dark' fontSize={0} regular>
        <Text.span>Exclusively for Priceline Members </Text.span>
      </StyledText>
      <Text color='text.dark' fontSize={0} regular>
        <Text.span>Tired of searching? Book now! </Text.span>
        <Text.span>
          <Button onClick={whenClicked} variation='link' aria-label={ariaLabel}>
            <RefundText fontSize={0} color='text.dark'>
              We&apos;ll refund the difference
            </RefundText>
          </Button>
        </Text.span>
        <Text.span> if you find a lower price.</Text.span>
      </Text>
    </BorderTopBox>
  )
}

BestPriceGuaranteeCard.propTypes = {
  theme: PropTypes.string,
  whenClicked: PropTypes.func,
  ariaLabel: PropTypes.string,
}
